const { createConstant } = require('../helpers')

const service = 'user-service'

module.exports = {
  GET_LOGGED_IN_USER: createConstant(service, 'GET_LOGGED_IN_USER'),
  GET_LOGGED_IN_USER_SUCCESS: createConstant(
    service,
    'GET_LOGGED_IN_USER_SUCCESS',
  ),
  GET_LOGGED_IN_USER_ERROR: createConstant(service, 'GET_LOGGED_IN_USER_ERROR'),
  GET_LOGGED_IN_USER_RESET: createConstant(service, 'GET_LOGGED_IN_USER_RESET'),

  // For Admin Users
  POST_USER: createConstant(service, 'POST_USER'),
  POST_USER_SUCCESS: createConstant(service, 'POST_USER_SUCCESS'),
  POST_USER_ERROR: createConstant(service, 'POST_USER_ERROR'),
  POST_USER_RESET: createConstant(service, 'POST_USER_RESET'),

  // For Admin Users
  IMPORT_USER: createConstant(service, 'IMPORT_USER'),
  IMPORT_USER_SUCCESS: createConstant(service, 'IMPORT_USER_SUCCESS'),
  IMPORT_USER_ERROR: createConstant(service, 'IMPORT_USER_ERROR'),
  IMPORT_USER_RESET: createConstant(service, 'IMPORT_USER_RESET'),

  // For Admin Users
  BULK_UPDATE_USER: createConstant(service, 'BULK_UPDATE_USER'),
  BULK_UPDATE_USER_SUCCESS: createConstant(service, 'BULK_UPDATE_USER_SUCCESS'),
  BULK_UPDATE_USER_ERROR: createConstant(service, 'BULK_UPDATE_USER_ERROR'),
  BULK_UPDATE_USER_RESET: createConstant(service, 'BULK_UPDATE_USER_RESET'),

  // For Admin Users
  GET_ALL_USERS: createConstant(service, 'GET_ALL_USERS'),
  GET_ALL_USERS_SUCCESS: createConstant(service, 'GET_ALL_USERS_SUCCESS'),
  GET_ALL_USERS_ERROR: createConstant(service, 'GET_ALL_USERS_ERROR'),
  GET_ALL_USERS_RESET: createConstant(service, 'GET_ALL_USERS_RESET'),

  // For Admin Users
  GET_SINGLE_USER: createConstant(service, 'GET_SINGLE_USER'),
  GET_SINGLE_USER_SUCCESS: createConstant(service, 'GET_SINGLE_USER_SUCCESS'),
  GET_SINGLE_USER_ERROR: createConstant(service, 'GET_SINGLE_USER_ERROR'),
  GET_SINGLE_USER_RESET: createConstant(service, 'GET_SINGLE_USER_RESET'),

  // For Admin Users
  UPDATE_USER: createConstant(service, 'UPDATE_USER'),
  UPDATE_USER_SUCCESS: createConstant(service, 'UPDATE_USER_SUCCESS'),
  UPDATE_USER_ERROR: createConstant(service, 'UPDATE_USER_ERROR'),
  UPDATE_USER_RESET: createConstant(service, 'UPDATE_USER_RESET'),

  // For Admin Users
  DELETE_USER: createConstant(service, 'DELETE_USER'),
  DELETE_USER_SUCCESS: createConstant(service, 'DELETE_USER_SUCCESS'),
  DELETE_USER_ERROR: createConstant(service, 'DELETE_USER_ERROR'),
  DELETE_USER_RESET: createConstant(service, 'DELETE_USER_RESET'),

  // For Admin Users
  GET_ADMIN_DOCTORS_LIST: createConstant(service, 'GET_ADMIN_DOCTORS_LIST'),
  GET_ADMIN_DOCTORS_LIST_SUCCESS: createConstant(
    service,
    'GET_ADMIN_DOCTORS_LIST_SUCCESS',
  ),
  GET_ADMIN_DOCTORS_LIST_ERROR: createConstant(
    service,
    'GET_ADMIN_DOCTORS_LIST_ERROR',
  ),
  GET_ADMIN_DOCTORS_LIST_RESET: createConstant(
    service,
    'GET_ADMIN_DOCTORS_LIST_RESET',
  ),

  // For Admin Users
  GET_ADMIN_DOCTOR: createConstant(service, 'GET_ADMIN_DOCTOR'),
  GET_ADMIN_DOCTOR_SUCCESS: createConstant(service, 'GET_ADMIN_DOCTOR_SUCCESS'),
  GET_ADMIN_DOCTOR_ERROR: createConstant(service, 'GET_ADMIN_DOCTOR_ERROR'),
  GET_ADMIN_DOCTOR_RESET: createConstant(service, 'GET_ADMIN_DOCTOR_RESET'),

  // For Admin Users
  CREATE_ADMIN_DOCTOR: createConstant(service, 'CREATE_ADMIN_DOCTOR'),
  CREATE_ADMIN_DOCTOR_SUCCESS: createConstant(
    service,
    'CREATE_ADMIN_DOCTOR_SUCCESS',
  ),
  CREATE_ADMIN_DOCTOR_ERROR: createConstant(
    service,
    'CREATE_ADMIN_DOCTOR_ERROR',
  ),
  CREATE_ADMIN_DOCTOR_RESET: createConstant(
    service,
    'CREATE_ADMIN_DOCTOR_RESET',
  ),

  // For Admin Users
  UPDATE_ADMIN_DOCTOR: createConstant(service, 'UPDATE_ADMIN_DOCTOR'),
  UPDATE_ADMIN_DOCTOR_SUCCESS: createConstant(
    service,
    'UPDATE_ADMIN_DOCTOR_SUCCESS',
  ),
  UPDATE_ADMIN_DOCTOR_ERROR: createConstant(
    service,
    'UPDATE_ADMIN_DOCTOR_ERROR',
  ),
  UPDATE_ADMIN_DOCTOR_RESET: createConstant(
    service,
    'UPDATE_ADMIN_DOCTOR_RESET',
  ),

  // For Admin Users
  UPDATE_ADMIN_DOCTOR_STATUS: createConstant(
    service,
    'UPDATE_ADMIN_DOCTOR_STATUS',
  ),
  UPDATE_ADMIN_DOCTOR_STATUS_SUCCESS: createConstant(
    service,
    'UPDATE_ADMIN_DOCTOR_STATUS_SUCCESS',
  ),
  UPDATE_ADMIN_DOCTOR_STATUS_ERROR: createConstant(
    service,
    'UPDATE_ADMIN_DOCTOR_STATUS_ERROR',
  ),
  UPDATE_ADMIN_DOCTOR_STATUS_RESET: createConstant(
    service,
    'UPDATE_ADMIN_DOCTOR_STATUS_RESET',
  ),

  // For Admin Users
  POST_ADMIN_DOCTOR_DIGITAL_SIG: createConstant(
    service,
    'POST_ADMIN_DOCTOR_DIGITAL_SIG',
  ),
  POST_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS: createConstant(
    service,
    'POST_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS',
  ),
  POST_ADMIN_DOCTOR_DIGITAL_SIG_ERROR: createConstant(
    service,
    'POST_ADMIN_DOCTOR_DIGITAL_SIG_ERROR',
  ),
  POST_ADMIN_DOCTOR_DIGITAL_SIG_RESET: createConstant(
    service,
    'POST_ADMIN_DOCTOR_DIGITAL_SIG_RESET',
  ),

  // For Admin Users
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG: createConstant(
    service,
    'POST_ADMIN_DOCTOR_REVOKE_DIGITAL_SIG',
  ),
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS: createConstant(
    service,
    'POST_ADMIN_DOCTOR_REVOKE_DIGITAL_SIG_SUCCESS',
  ),
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_ERROR: createConstant(
    service,
    'POST_ADMIN_DOCTOR_REVOKE_DIGITAL_SIG_ERROR',
  ),
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_RESET: createConstant(
    service,
    'POST_ADMIN_DOCTOR_REVOKE_DIGITAL_SIG_RESET',
  ),

  // For Admin Users
  POST_ADMIN_DOCTOR_AUTH_PIN: createConstant(service, 'POST_ADMIN_DOCTOR_AUTH_PIN'),
  POST_ADMIN_DOCTOR_AUTH_PIN_SUCCESS: createConstant(service, 'POST_ADMIN_DOCTOR_AUTH_PIN_SUCCESS'),
  POST_ADMIN_DOCTOR_AUTH_PIN_ERROR: createConstant(service, 'POST_ADMIN_DOCTOR_AUTH_PIN_ERROR'),
  POST_ADMIN_DOCTOR_AUTH_PIN_RESET: createConstant(service, 'POST_ADMIN_DOCTOR_AUTH_PIN_RESET'),

  // For Admin Users
  POST_ADMIN_DOCTOR_SPECS: createConstant(service, 'POST_ADMIN_DOCTOR_SPECS'),
  POST_ADMIN_DOCTOR_SPECS_SUCCESS: createConstant(
    service,
    'POST_ADMIN_DOCTOR_SPECS_SUCCESS',
  ),
  POST_ADMIN_DOCTOR_SPECS_ERROR: createConstant(
    service,
    'POST_ADMIN_DOCTOR_SPECS_ERROR',
  ),
  POST_ADMIN_DOCTOR_SPECS_RESET: createConstant(
    service,
    'POST_ADMIN_DOCTOR_SPECS_RESET',
  ),

  // For Admin Users
  DELETE_ADMIN_DOCTOR: createConstant(service, 'DELETE_ADMIN_DOCTOR'),
  DELETE_ADMIN_DOCTOR_SUCCESS: createConstant(
    service,
    'DELETE_ADMIN_DOCTOR_SUCCESS',
  ),
  DELETE_ADMIN_DOCTOR_ERROR: createConstant(
    service,
    'DELETE_ADMIN_DOCTOR_ERROR',
  ),
  DELETE_ADMIN_DOCTOR_RESET: createConstant(
    service,
    'DELETE_ADMIN_DOCTOR_RESET',
  ),

  // For Admin Panel
  GET_ALL_ADMIN_PANEL_USERS: createConstant(
    service,
    'GET_ALL_ADMIN_PANEL_USERS',
  ),
  GET_ALL_ADMIN_PANEL_USERS_SUCCESS: createConstant(
    service,
    'GET_ALL_ADMIN_PANEL_USERS_SUCCESS',
  ),
  GET_ALL_ADMIN_PANEL_USERS_ERROR: createConstant(
    service,
    'GET_ALL_ADMIN_PANEL_USERS_ERROR',
  ),
  GET_ALL_ADMIN_PANEL_USERS_RESET: createConstant(
    service,
    'GET_ALL_ADMIN_PANEL_USERS_RESET',
  ),

  // For Admin Panel
  GET_SINGLE_ADMIN_PANEL_USER: createConstant(
    service,
    'GET_SINGLE_ADMIN_PANEL_USER',
  ),
  GET_SINGLE_ADMIN_PANEL_USER_SUCCESS: createConstant(
    service,
    'GET_SINGLE_ADMIN_PANEL_USER_SUCCESS',
  ),
  GET_SINGLE_ADMIN_PANEL_USER_ERROR: createConstant(
    service,
    'GET_SINGLE_ADMIN_PANEL_USER_ERROR',
  ),
  GET_SINGLE_ADMIN_PANEL_USER_RESET: createConstant(
    service,
    'GET_SINGLE_ADMIN_PANEL_USER_RESET',
  ),

  // For Admin Panel
  CREATE_ADMIN_PANEL_USER: createConstant(service, 'CREATE_ADMIN_PANEL_USER'),
  CREATE_ADMIN_PANEL_USER_SUCCESS: createConstant(
    service,
    'CREATE_ADMIN_PANEL_USER_SUCCESS',
  ),
  CREATE_ADMIN_PANEL_USER_ERROR: createConstant(
    service,
    'CREATE_ADMIN_PANEL_USER_ERROR',
  ),
  CREATE_ADMIN_PANEL_USER_RESET: createConstant(
    service,
    'CREATE_ADMIN_PANEL_USER_RESET',
  ),

  // For Admin Panel
  UPDATE_ADMIN_PANEL_USER: createConstant(service, 'UPDATE_ADMIN_PANEL_USER'),
  UPDATE_ADMIN_PANEL_USER_SUCCESS: createConstant(
    service,
    'UPDATE_ADMIN_PANEL_USER_SUCCESS',
  ),
  UPDATE_ADMIN_PANEL_USER_ERROR: createConstant(
    service,
    'UPDATE_ADMIN_PANEL_USER_ERROR',
  ),
  UPDATE_ADMIN_PANEL_USER_RESET: createConstant(
    service,
    'UPDATE_ADMIN_PANEL_USER_RESET',
  ),

  // Forgot password screens
  FORGOT_PASSWORD: createConstant(service, 'FORGOT_PASSWORD'),
  FORGOT_PASSWORD_SUCCESS: createConstant(service, 'FORGOT_PASSWORD_SUCCESS'),
  FORGOT_PASSWORD_ERROR: createConstant(service, 'FORGOT_PASSWORD_ERROR'),
  FORGOT_PASSWORD_RESET: createConstant(service, 'FORGOT_PASSWORD_RESET'),

  GET_PROFILE: createConstant(service, 'GET_PROFILE'),
  GET_PROFILE_SUCCESS: createConstant(service, 'GET_PROFILE_SUCCESS'),
  GET_PROFILE_ERROR: createConstant(service, 'GET_PROFILE_ERROR'),
  GET_PROFILE_RESET: createConstant(service, 'GET_PROFILE_RESET'),

  POST_DOC_DIGITAL_INFO: createConstant(service, 'POST_DOC_DIGITAL_INFO'),
  POST_DOC_DIGITAL_INFO_SUCCESS: createConstant(
    service,
    'POST_DOC_DIGITAL_INFO_SUCCESS',
  ),
  POST_DOC_DIGITAL_INFO_ERROR: createConstant(
    service,
    'POST_DOC_DIGITAL_INFO_ERROR',
  ),
  POST_DOC_DIGITAL_INFO_RESET: createConstant(
    service,
    'POST_DOC_DIGITAL_INFO_RESET',
  ),
  UPDATE_PROFILE: createConstant(service, 'UPDATE_PROFILE'),
  UPDATE_PROFILE_SUCCESS: createConstant(service, 'UPDATE_PROFILE_SUCCESS'),
  UPDATE_PROFILE_ERROR: createConstant(service, 'UPDATE_PROFILE_ERROR'),
  UPDATE_PROFILE_RESET: createConstant(service, 'UPDATE_PROFILE_RESET'),

  USER_LOGIN: createConstant(service, 'USER_LOGIN'),
  USER_LOGIN_SUCCESS: createConstant(service, 'USER_LOGIN_SUCCESS'),
  USER_LOGIN_ERROR: createConstant(service, 'USER_LOGIN_ERROR'),
  USER_LOGIN_RESET: createConstant(service, 'USER_LOGIN_RESET'),

  USER_REGISTRATION: createConstant(service, 'USER_REGISTRATION'),
  USER_REGISTRATION_SUCCESS: createConstant(
    service,
    'USER_REGISTRATION_SUCCESS',
  ),
  USER_REGISTRATION_ERROR: createConstant(service, 'USER_REGISTRATION_ERROR'),
  USER_REGISTRATION_RESET: createConstant(service, 'USER_REGISTRATION_RESET'),

  APPLE_LOGIN: createConstant(service, 'APPLE_LOGIN'),
  APPLE_LOGIN_SUCCESS: createConstant(service, 'APPLE_LOGIN_SUCCESS'),
  APPLE_LOGIN_ERROR: createConstant(service, 'APPLE_LOGIN_ERROR'),
  APPLE_LOGIN_RESET: createConstant(service, 'APPLE_LOGIN_RESET'),

  LOGIN_GOOGLE: createConstant(service, 'LOGIN_GOOGLE'),
  LOGIN_GOOGLE_SUCCESS: createConstant(service, 'LOGIN_GOOGLE_SUCCESS'),
  LOGIN_GOOGLE_ERROR: createConstant(service, 'LOGIN_GOOGLE_ERROR'),
  LOGIN_GOOGLE_RESET: createConstant(service, 'LOGIN_GOOGLE_RESET'),

  UPDATE_EMAIL: createConstant(service, 'UPDATE_EMAIL'),
  UPDATE_EMAIL_SUCCESS: createConstant(service, 'UPDATE_EMAIL_SUCCESS'),
  UPDATE_EMAIL_ERROR: createConstant(service, 'UPDATE_EMAIL_ERROR'),
  UPDATE_EMAIL_RESET: createConstant(service, 'UPDATE_EMAIL_RESET'),

  UPDATE_NUMBER: createConstant(service, 'UPDATE_NUMBER'),
  UPDATE_NUMBER_SUCCESS: createConstant(service, 'UPDATE_NUMBER_SUCCESS'),
  UPDATE_NUMBER_ERROR: createConstant(service, 'UPDATE_NUMBER_ERROR'),
  UPDATE_NUMBER_RESET: createConstant(service, 'UPDATE_NUMBER_RESET'),

  NUMBER_VALIDATION: createConstant(service, 'NUMBER_VALIDATION'),
  NUMBER_VALIDATION_SUCCESS: createConstant(
    service,
    'NUMBER_VALIDATION_SUCCESS',
  ),
  NUMBER_VALIDATION_ERROR: createConstant(service, 'NUMBER_VALIDATION_ERROR'),
  NUMBER_VALIDATION_RESET: createConstant(service, 'NUMBER_VALIDATION_RESET'),

  USER_LOGOUT: createConstant(service, 'USER_LOGOUT'),
  USER_LOGOUT_SUCCESS: createConstant(service, 'USER_LOGOUT_SUCCESS'),
  USER_LOGOUT_ERROR: createConstant(service, 'USER_LOGOUT_ERROR'),

  PASSWORD_CHANGE: createConstant(service, 'PASSWORD_CHANGE'),
  PASSWORD_CHANGE_SUCCESS: createConstant(service, 'PASSWORD_CHANGE_SUCCESS'),
  PASSWORD_CHANGE_ERROR: createConstant(service, 'PASSWORD_CHANGE_ERROR'),
  PASSWORD_CHANGE_RESET: createConstant(service, 'PASSWORD_CHANGE_RESET'),

  MARKETPLACE_PASSWORD_CHANGE: createConstant(
    service,
    'MARKETPLACE_PASSWORD_CHANGE',
  ),
  MARKETPLACE_PASSWORD_CHANGE_SUCCESS: createConstant(
    service,
    'MARKETPLACE_PASSWORD_CHANGE_SUCCESS',
  ),
  MARKETPLACE_PASSWORD_CHANGE_ERROR: createConstant(
    service,
    'MARKETPLACE_PASSWORD_CHANGE_ERROR',
  ),
  MARKETPLACE_PASSWORD_CHANGE_RESET: createConstant(
    service,
    'MARKETPLACE_PASSWORD_CHANGE_RESET',
  ),
  //FOR EMAIL OTP
  EMAIL_OTP: createConstant(service, 'EMAIL_OTP'),
  EMAIL_OTP_SUCCESS: createConstant(service, 'EMAIL_OTP_SUCCESS'),
  EMAIL_OTP_ERROR: createConstant(service, 'EMAIL_OTP_ERROR'),
  EMAIL_OTP_RESET: createConstant(service, 'EMAIL_OTP_RESET'),


  GET_DOCTOR_DETAILS: createConstant(service, 'GET_DOCTOR_DETAILS'),
  GET_DOCTOR_DETAILS_SUCCESS: createConstant(service, 'GET_DOCTOR_DETAILS_SUCCESS'),
  GET_DOCTOR_DETAILS_ERROR: createConstant(service, 'GET_DOCTOR_DETAILS_ERROR'),
  GET_DOCTOR_DETAILS_RESET: createConstant(service, 'GET_DOCTOR_DETAILS_RESET'),

  GET_DOCTOR_ID: createConstant(service, 'GET_DOCTOR_ID'),
  GET_DOCTOR_ID_SUCCESS: createConstant(service, 'GET_DOCTOR_ID_SUCCESS'),
  GET_DOCTOR_ID_ERROR: createConstant(service, 'GET_DOCTOR_ID_ERROR'),
  GET_DOCTOR_ID_RESET: createConstant(service, 'GET_DOCTOR_ID_RESET'),

  POST_DOCTOR_PIN: createConstant(service, 'POST_DOCTOR_PIN'),
  POST_DOCTOR_PIN_SUCCESS: createConstant(service, 'POST_DOCTOR_PIN_SUCCESS'),
  POST_DOCTOR_PIN_ERROR: createConstant(service, 'POST_DOCTOR_PIN_ERROR'),
  POST_DOCTOR_PIN_RESET: createConstant(service, 'POST_DOCTOR_PIN_RESET'),
}